import { put, SagaGenerator } from "typed-redux-saga";

import { Localizable } from "@com.mgmtp.a12.utils/utils-localization/lib/main";
import { LoggerFactory } from "@com.mgmtp.a12.utils/utils-logging";

import { createCustomNotificationAction } from "../app/actions";
import { RESOURCE_KEYS } from "../localization";

import { isString } from "./typeGuardUtils";

const logger = LoggerFactory.getLogger("notificationUtils");

export function* putErrorNotification(
	message: Localizable | string,
	error: unknown,
	activityId?: string,
	group?: string
): SagaGenerator<void> {
	logger.error(error);
	yield* put(
		createCustomNotificationAction({
			title: { key: RESOURCE_KEYS.features.notification.title.error },
			message: isString(message) ? { key: message } : message,
			icon: "error",
			severity: "error",
			activityId,
			group
		})
	);
}

export function* putSuccessNotification(
	message: Localizable | string,
	activityId?: string,
	group?: string
): SagaGenerator<void> {
	yield* put(
		createCustomNotificationAction({
			message: isString(message) ? { key: message } : message,
			icon: "done",
			severity: "success",
			activityId,
			group
		})
	);
}
